<template>
  <button
    key="follow-button"
    @click.prevent="handleUserFollowTrainer(trainerId, 1)"
    v-if="!isFollow"
    class="text-green-light ring-1 ring-green-light rounded-lg focus:outline-none hover:shadow-lg"
    :class="classStr"
  >
    Follow
  </button>
  <button
    key="unfollow-button"
    @mouseover="handleMouseOver($event, 'Unfollow')"
    @mouseout="handleMouseOver($event, 'Following')"
    @click.prevent="handleUserFollowTrainer(trainerId, 0)"
    v-else
    class="bg-green-light rounded-lg text-white ring-1 ring-gray-300 hover:ring-1 hover:ring-red-600 hover:text-red-500 hover:bg-white focus:outline-none"
    :class="classStr"
  >
    Following
  </button>
</template>
<script>
export default {
  name: "FollowTrainerButton",
  props: {
    isFollow: Number,
    handleUserFollowTrainer: Function,
    trainerId: Number,
    classStr: String,
  },
  methods: {
    handleMouseOver(e, text) {
      e.target.innerText = text;
    },
  },
};
</script>
